var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './analyticsFilterLayoutRow.module.scss';
export const AnalyticsFilterLayoutRow = forwardRef(function AnalyticsFilterLayoutRow(_a, ref) {
    var { children, noPadding = false } = _a, rowProps = __rest(_a, ["children", "noPadding"]);
    return (_jsx(Column.Row, Object.assign({ ref: ref, className: classNames(styles.root, {
            [styles.padded]: !noPadding,
            [styles.scrollable]: rowProps.scrollable,
        }), noHorizontalPadding: true, noVerticalPadding: true, noMinHeight: true }, rowProps, { children: children })));
});
